import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { getFileNamesPreviewValue } from '@/features/ui/DocumentsData/ui/utils';

import { FormDatePicker, FormDocumentUploader, FormTextInput, Grid, StepControlPanel } from '@/shared/ui';

import { useERZDocumentTypes } from '@/modules/erz/helpers';

import { formatDate } from '@/helpers/dates';

import { DocumentTypeCode } from '@/api/types';

import { ExpertResearchDataSchema } from '../../model/types';

export const ExpertResearchStep: React.FC<StepProps> = ({ next, prev, currentRequestId, onStepDraftSave }) => {
  const { control } = useFormContext<ExpertResearchDataSchema>();

  const { data: expertResearchDocs = [] } = useERZDocumentTypes({
    allowedDocumentTypeCodes: [DocumentTypeCode.EXPERT_RESEARCH],
  });
  const expertResearch = expertResearchDocs[0] ?? null;

  return (
    <>
      <FormBlock title="Дані експертних досліджень">
        <FormTextInput
          name="expertOrganization"
          control={control}
          label="Найменування органу експертної служби"
          placeholder="Введіть дані"
          required
        />
        <FormDatePicker name="examinationDate" control={control} maxDateToday required label="Дата обстеження" />
        <FormDocumentUploader
          name="expertResearch"
          control={control}
          maxCount={3}
          required
          label="Документ що затверджує пройдену експертизу"
          request_id={currentRequestId ?? ''}
          onSaveDraft={onStepDraftSave}
          docTypeMeta={expertResearch ?? undefined}
        />
      </FormBlock>
      <StepControlPanel prev={prev} next={next} />
    </>
  );
};

export const ExpertResearchStepPreview: React.FC = () => {
  const { getValues } = useFormContext<ExpertResearchDataSchema>();
  const { expertOrganization, examinationDate, expertResearch } = getValues();

  return (
    <Grid
      title="Дані експертних досліджень"
      data={[
        ['Найменування органу експертної служби', expertOrganization],
        ['Дата обстеження', formatDate(examinationDate)],
        ['Документ що затверджує пройдену експертизу', getFileNamesPreviewValue(expertResearch?.fileNames)],
      ]}
    />
  );
};
